import axios from 'axios';

const cube = axios.create({
  baseURL: process.env.REACT_APP_CUBE_API,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    authorization: process.env.REACT_APP_CUBE_SECRET
  },
  responseType: 'json',
});

export default cube;
